<template>
  <a-modal width="900px" :visible="visible" :title="$t('protocol.virtualPointTitle')" @cancel="close" @ok="ok">
    <a-space style="display: flex;margin-bottom: 20px">
      <a-input v-model="content" :placeholder="$t('linkage.searchPoints')" allowClear @change="onChange" />
      <a-button type="primary" @click="onSearch">{{ $t('buttons.search') }}</a-button>
    </a-space>
    <a-table
      style="margin-bottom: 20px"
      :pagination="{ pageSize: 500, hideOnSinglePage: true }"
      :row-key="point => point.code"
      :row-selection="{
        type: 'radio',
        selectedRowKeys: selectRowKeys,
        onSelect: selectRow
      }"
      :scroll="{ y: 250 }"
      :columns="columns"
      :data-source="list">
    </a-table>
    <a-input ref="expression" v-model="expression" />
  </a-modal>
</template>

<script>
export default {
  name: 'VirtualPointModal',
  model: {
    prop: 'record',
    event: 'change'
  },
  props: {
    visible: Boolean,
    record: {
      type: Object,
      default: () => {}
    },
    points: Array
  },
  data () {
    return {
      columns: [
        {
          title: () => this.$t('linkage.code'),
          dataIndex: 'code',
          key: 'code'
        },
        {
          title: () => this.$t('linkage.name'),
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: () => this.$t('linkage.unit'),
          dataIndex: 'unit',
          key: 'unit'
        },
        {
          title: () => this.$t('linkage.coefficient'),
          dataIndex: 'coefficient',
          key: 'coefficient'
        }
      ],
      list: [],
      expression: this.record.expression,
      content: '',
      selectRowKeys: []
    }
  },
  watch: {
    visible (val, oldVal) {
      if (val) {
        this.list = this.points
        this.selectRowKeys = []
      }
      if (this.record.expression) {
        this.expression = this.record.expression
      } else {
        this.expression = ''
      }
    }
  },
  methods: {
    ok () {
      this.record.expression = this.expression
      this.$emit('close')
    },
    close () {
      this.$emit('close')
    },
    selectRow (record) {
      const dom = this.$refs.expression.$el
      const startPos = dom.selectionStart
      const endPos = dom.selectionEnd
      this.expression = this.expression.substring(0, startPos) + `#${record.code}` + this.expression.substring(endPos, this.expression.length)
      this.$nextTick()
    },
    onSearch () {
      this.list = this.points.filter(point => {
        return point.code.toUpperCase().indexOf(this.content.toUpperCase()) >= 0 || point.name.indexOf(this.content) >= 0
      })
    },
    onChange (e) {
      this.list = this.points.filter(point => {
        return point.code.toUpperCase().indexOf(this.content.toUpperCase()) >= 0 || point.name.indexOf(this.content) >= 0
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-table-row {
  cursor: pointer;
}
</style>
